import { handleValidation } from "./validation.js";

const handleFormSubmit = () => {
  function formSubmit() {
    const forms = document.querySelectorAll(".js-sk-form");
    forms.forEach((form) => {
      const message = form.nextElementSibling;
      const submit = form.querySelector("input[type=submit]");
      const loader = form.previousElementSibling;

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        const valid = handleValidation(form);

        if (!valid) {
          return;
        }

        submit.setAttribute("disabled", true);
        loader.classList.remove("hidden");

        const formData = new FormData(this);
        fetch(themeVars.ajax_url, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
          })
          .then((data) => {
            submit.setAttribute("disabled", false);
            loader.classList.add("hidden");
            message.innerText = data.message;
            setTimeout(() => {
              form.remove();
              message.classList.remove("hidden");
            }, 300);
          })
          .catch((error) => {
            console.error(
              "There was a problem with the fetch operation:",
              error
            );
          });
      });
    });
  }

  return {
    init() {
      formSubmit();
    },
  };
};

export { handleFormSubmit };

